// This file is generated automatically by scripts/generate-icon.js. Don't modify it.

import UserReviewStar from '../_raw/ui/icon_user_review_star.svg';
import withIconProps from '../withIconProps';

export default withIconProps(UserReviewStar);
